var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',[_c('v-row',{attrs:{"justify":"end","no-gutters":""}},[_c('v-btn',{attrs:{"href":_vm.getLink,"text":"","target":"_blank"}},[_vm._v(" "+_vm._s(_vm.$t("privacy-policy"))+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }